// Ensure GSAP is available globally before running this script.

// Insert optimized inline CSS.
const styleEl = document.createElement("style");
styleEl.textContent = `
  .svg-container {
    position: absolute;
    bottom: -100px;
    right: 10%;
    z-index: 999;
    width: 75px;
    height: auto;
    transform-origin: center center;
    will-change: transform;
    backface-visibility: hidden;
    transform: translateZ(0);
  }
  .svg-container.behind {
    z-index: -1;
  }
  .svg-container.front {
    z-index: 9999;
  }
  .svg-container img {
    display: block;
    width: 100%;
    height: auto;
    filter: drop-shadow(0 5px 15px rgba(0,0,0,0.1));
  }
    `;
document.head.appendChild(styleEl);

// Get the parent element and ensure it is relatively positioned.
const categoryGrid = document.querySelector(".category-grid");
if (categoryGrid) {
  categoryGrid.style.position = "relative";
}

// Create a container for the image.
const container = document.createElement("div");
container.className = "svg-container";
if (categoryGrid) {
  categoryGrid.appendChild(container);
}

// Set the starting bottom value.
let containerBottom = -100;
let lastScrollPosition = window.pageYOffset;
let lastTimestamp = 0;

// Create a picture element for modern image format support
const picture = document.createElement("picture");
container.appendChild(picture);

// WebP source using Shopify's format parameter
const sourceWebP = document.createElement("source");
// Use format=webp query parameter to request WebP version from Shopify CDN
sourceWebP.srcset = "https://cdn.shopify.com/s/files/1/0887/0808/8139/files/fish_583c79e5-0975-4e10-803b-e18af00eab02.png?v=1743596784&format=webp";
sourceWebP.type = "image/webp";
picture.appendChild(sourceWebP);

// Create and append the fallback image element
const img = document.createElement("img");
img.src = "https://cdn.shopify.com/s/files/1/0887/0808/8139/files/fish_583c79e5-0975-4e10-803b-e18af00eab02.png?v=1743596784";
img.alt = "Fish decoration";
img.loading = "lazy"; // Prioritize loading
img.width = 75; // Set explicit width
img.height = 45; // Set explicit height based on approximate aspect ratio
img.setAttribute('fetchpriority', 'high'); // High priority for LCP
picture.appendChild(img);

// Pre-load the image to avoid animation delays
const preloadImg = new Image();
preloadImg.src = img.src;

// Improved parallax configuration
const parallaxSpeed = 0.3; // Slightly faster parallax movement
const smoothFactor = 0.08; // Lower values = smoother, higher values = more immediate

// Smoother animation using lerp (linear interpolation)
let targetBottom = containerBottom;

// Track animation state
let baseY = 0;
let floatingY = 0;

// Animation settings - more subtle
const floatAmplitude = 5; // Reduced from 10 to 5 pixels
const floatPeriod = 2000; // Slower, more gentle movement (increased from 1200 to 2000ms)

// Update the animation with time-based smoothing
function updateParallax(timestamp) {
  // Calculate delta time for smooth animations regardless of frame rate
  const deltaTime = timestamp - lastTimestamp || 0;
  lastTimestamp = timestamp;
  
  // Add very subtle continuous floating movement (sine wave with reduced amplitude and slower frequency)
  floatingY = Math.sin(timestamp / floatPeriod) * floatAmplitude;
  
  const gridRect = categoryGrid.getBoundingClientRect();
  if (gridRect.top < window.innerHeight && gridRect.bottom > 0) {
    const currentScroll = window.pageYOffset;
    const scrollDelta = currentScroll - lastScrollPosition;
    
    // Update target position based on scroll
    targetBottom += scrollDelta * parallaxSpeed;
    
    // Smooth interpolation between current and target positions
    containerBottom += (targetBottom - containerBottom) * Math.min(smoothFactor * (deltaTime / 16), 1);
    
    // Store base Y position for scrolling
    baseY = -containerBottom;
    
    lastScrollPosition = currentScroll;
  }
  
  // Apply the combined transform for better performance 
  // (using translate3d for hardware acceleration)
  // Combine both the scroll-based position and the floating animation
  container.style.transform = `translate3d(0, ${baseY + floatingY}px, 0)`;
  container.style.bottom = "0"; // Fixed position, movement handled by transform
  
  requestAnimationFrame(updateParallax);
}

// Start the animation loop
requestAnimationFrame(updateParallax);

// Optimized GSAP animation - just for rotation and horizontal movement (very subtle)
gsap.to(container, {
  x: "+=8", // More subtle horizontal movement
  rotation: 2, // Very slight rotation
  duration: 4, // Longer duration for even smoother feel
  yoyo: true,
  repeat: -1,
  ease: "sine.inOut", // Smoother sine wave easing
  onStart: () => {
    // Ensure GPU acceleration
    gsap.set(container, {force3D: true});
  }
});
